{
	"errorPage.404.button": "Volver a la página de inicio",
	"errorPage.404.code": "Error 404",
	"errorPage.404.description": "Lo sentimos, la página que buscas no existe o se ha trasladado.",
	"errorPage.404.title": "Página no encontrada...",
	"errorPage.network.description": "No pudimos cargar la página.\nComprueba tu configuración de Internet e inténtalo de nuevo.",
	"errorPage.network.title": "Se ha producido un error…",
	"global.refreshButton": "Actualizar",
	"global.toast.error.message": "Se ha producido un error, inténtelo de nuevo.",
	"global.toast.error.title": "Error"
}
